export const REACTION_EMOJIS = {
  '+1': '👍',
  heart: '❤️',
  smile: '😄',
  open_mouth: '😮',
  tada: '🎉',
  clap: '👏',
  rocket: '🚀',
};

export const DEFAULT_REACTIONS = [...Object.keys(REACTION_EMOJIS), 'care'];

/** Must match apps/back `MAX_COMPANY_REACTIONS` */
export const MAX_COMPANY_REACTIONS = 30;

const REACTIONS = DEFAULT_REACTIONS;

export default REACTIONS;
